import React from 'react'

const HandBag = ({ width, height }) => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 12.944 15.594"
      >
        <path
          data-name="Path 943"
          d="M3.41 7.23h12.044v8.413a2.264 2.264 0 0 1-2.264 2.264H5.674a2.264 2.264 0 0 1-2.264-2.264V7.23z"
          transform="translate(-2.96 -2.763)"
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: 10,
            strokeWidth: '.9px',
          }}
        />
        <path
          data-name="Path 944"
          d="M8.18 7.522V4.178A2.678 2.678 0 0 1 10.858 1.5a2.678 2.678 0 0 1 2.678 2.678v3.344"
          transform="translate(-4.386 -1.05)"
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: 10,
            strokeWidth: '.9px',
          }}
        />
      </svg>
    </div>
  )
}

export default HandBag
